// Standalone /skills page — the Skill Layer brief. Routed at the top level in index.js
// (same pattern as /play-engine and /data-dictionary), so it renders outside the app shell.
// The content is the self-contained static doc in public/skills.html; we embed it in a
// full-viewport iframe so its page-level styles stay fully isolated.
export default function Skills() {
  return (
    <iframe
      title="Pollis — The Skill Layer"
      src={`${process.env.PUBLIC_URL || ""}/skills.html`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
